export const ScheduleHead = "Cleaning Schedule Information"
export const Search = "Search by store id or name"
export const NewSchedule = "+Add New Schedule"
export const StoreId = "StoreId"
export const StoreName = "Store Name"
export const SupplierName = "Supplier Name"
export const CleanersPerDay = "Number of cleaner(s) per day"
export const Sun = "Sun"
export const Mon = "Mon"
export const Tue = "Tue"
export const Wed = "Wed"
export const Thu = "Thu"
export const Fri = "Fri"
export const Sat = "Sat"
export const Action = "Action"
export const CreateNew = "Create New Schedule"
export const EditSchedule = "Edit Schedule"
export const Mandatory  = "indicates mandatory field"
export const Cancel  = "Cancel"
export const ScheduleAdded  = "Schedule added successfully..."
export const ScheduleUpdated  = "Schedule updated successfully..."
 export const Select  = "Select"
export const AlreadyPresent = "CleanerSchedule for store is already present"
export const CleaningScheduleEmpty  = "0"
export const StoreEmpty  = "Please enter storeId or storename"
export const StoreInValid  = "Invalid store id"
export const StoreNotSelect  = "Please select store"
export const SupplierNotSelect  = "Please select supplier name"